import Reveal from "../components/Reveal";
import PageHeader from "../components/PageHeader";
import CTABand from "../components/CTABand";
import { SOLUTIONS, IMAGES } from "../data/content";

const Solutions = () => (
  <main data-testid="solutions-page">
    <PageHeader
      eyebrow="Business Outcomes"
      title="Solutions"
      description="Solution areas where our engineering services come together to deliver measurable business outcomes."
    />
    <section className="bg-white py-20 lg:py-24">
      <div className="container-site">
        <div className="grid gap-x-16 gap-y-14 md:grid-cols-2">
          {SOLUTIONS.map((solution, i) => (
            <Reveal key={solution.title} delay={(i % 2) * 100}>
              <article className="border-t-2 border-brand-graphite pt-8" data-testid={`solution-item-${i}`}>
                <span className="font-heading text-sm font-semibold text-brand-red">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h2 className="mt-3 text-xl font-semibold">{solution.title}</h2>
                <p className="mt-3 text-base leading-relaxed text-brand-grey">
                  {solution.description}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-20">
          <img
            src={IMAGES.angularRed}
            alt="Angular geometric structure in red"
            className="v-clip aspect-[21/9] w-full object-cover"
            loading="lazy"
            data-testid="solutions-accent-image"
          />
        </Reveal>
      </div>
    </section>
    <CTABand />
  </main>
);

export default Solutions;
